export default __webpack_public_path__ + "static/media/Yash Pame.cf04067d.jpeg";